import MessageList from './message-list';
import MessageBrokerUtils from '@bonprix/pattern-library/components/message-broker-utils';
import PatternLibraryMessages from '@bonprix/pattern-library/components/messages';

const MessageMethods = {
    isValidMessageData: (messageData) => { return messageData && messageData.constructor === Object; },
    dataContainsProperty: function(property, messageData) { return this.isValidMessageData(messageData) && messageData.hasOwnProperty(property); }
};

const ExtractedMessages = MessageBrokerUtils.extractMessages(MessageList);
const EnhancedMessages = mergeDeep({}, MessageMethods, ExtractedMessages, PatternLibraryMessages);

Object.freeze(EnhancedMessages);

export default EnhancedMessages;

//https://stackoverflow.com/questions/27936772/how-to-deep-merge-instead-of-shallow-merge#answer-34749873
function isObject(item) {
    return (item && typeof item === 'object' && !Array.isArray(item));
}
function mergeDeep(target, ...sources) {
    if (!sources.length) {return target;}
    const source = sources.shift();

    if (isObject(target) && isObject(source)) {
        for (const key in source) {
            if (isObject(source[key])) {
                if (!target[key]) {Object.assign(target, { [key]: {} });}
                mergeDeep(target[key], source[key]);
            } else {
                Object.assign(target, { [key]: source[key] });
            }
        }
    }
    return mergeDeep(target, ...sources);
}